import { render } from "./WalletPanel.vue?vue&type=template&id=2bbc497b&scoped=true"
import script from "./WalletPanel.vue?vue&type=script&lang=ts"
export * from "./WalletPanel.vue?vue&type=script&lang=ts"

import "./WalletPanel.vue?vue&type=style&index=0&id=2bbc497b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bbc497b"

export default script